import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconBoostingPauseProps } from './IconBoostingPause.types'
import * as Styled from './styles/IconBoostingPause.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBoostingPause: FC<IconBoostingPauseProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBoostingPauseProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconBoostingPauseProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M12.078 15.75a1.274 1.274 0 1 1-1.277 1.266H2.5m0-8.618c5.242-5.246 13.746-5.25 18.992-.007'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M5.25 11.273c3.742-3.75 9.816-3.753 13.566-.007M8.074 14.094a5.576 5.576 0 0 1 7.883 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconBoostingPause
